<signage-display [manualNavigation]="true" />
